<mat-expansion-panel disabled
  class="accordion-form-section"
  [expanded]="expanded"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
>
  <mat-expansion-panel-header collapsedHeight="35px" expandedHeight="35px">
    <mat-panel-title>
      <i class="material-icons md-18 md-btn-align">subject</i>
      {{ title | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="scrollable-content">
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
